<template>
  <b-modal
    id="redirect-connexion-modal"
    class="redirect-connexion-full-screen-modal"
    @ok="handleOk"
    centered
    no-close-on-esc
    ok-variant="primary">

    <template #modal-header="{ close }">
      <div class="redirect-connexion-header-content w-100">
        <div class="redirect-connexion-bg-veilleur h-75"></div>
        <img :src="require(`@/assets/images/b122/img-perso-ok.png`)" class="redirect-connexion-step-img">
      </div>
    </template>

    <div>
      <div>
        <h1 class="page-title">{{username}}</h1>
        <p class="redirect-connexion-text mt-2" v-html="$t('redirect.connexion.text')"></p>
      </div>
    </div>


    <template #modal-footer="{ ok }">
      <div class="w-100 d-flex">
        <b-button  class="w-100" variant="primary"  @click="handleOk($event)">
          <div class="d-flex justify-content-center">
            <span class="align-self-center mt-small-px">{{$t('redirect.connexion.btn')}}</span> <i class="ph-custom ph-caret-circle-right-bold ml-1 align-self-center"/>
          </div>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>

export default {

  props:{
    username: {
      default: ""
    },
    redirectConnexionUrl: {
      default: ""
    },
  },

  methods: {

    handleOk(e) {
      e.preventDefault()
      window.open(this.redirectConnexionUrl, '_self')
    },

  },
};
</script>

<!-- not scoped car modal --><style>
#redirect-connexion-modal .modal-content,
#redirect-connexion-modal .modal-header,
#redirect-connexion-modal .modal-body,
#redirect-connexion-modal .modal-footer{
  background-color: var(--main-black-dark);
}

.redirect-connexion-step-img{
  max-width: 200px;
}
.redirect-connexion-header-content {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border-bottom: none;
}

.redirect-connexion-bg-veilleur {
  flex-shrink: 0;
  border-radius: 95px;
  background-color: var(--main-black-medium);
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
}

.redirect-connexion-step-img {
  max-width: 200px;
  min-width: 100px;
  z-index: 1;
}

.redirect-connexion-text{
  color: var(--main-grey-medium);
}

#redirect-connexion-modal .modal-content {
  overflow: hidden;
  border-radius: 30px;
}

.redirect-connexion-full-screen-modal .modal-dialog {
  max-width: 100%;
  margin: 0;
}
.redirect-connexion-full-screen-modal .modal-content {
  height: auto;
  border-radius: 30px;
}

@media (max-width: 767px) {
  #redirect-connexion-modal .modal-content {
    display: flex;
    overflow: auto;
  }

  #redirect-connexion-modal .modal-body{
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #redirect-connexion-modal .modal-dialog {
    max-width: 100%;
    margin: 0;
  }
  #redirect-connexion-modal .modal-content {
    padding: 0;
    margin: 8px;
  }
  .redirect-connexion-header-content, .redirect-connexion-text {
    padding: 10px;
  }
  .redirect-connexion-step-img {
    max-width: 100px;
  }
}

@media (max-height: 852px) {
  #redirect-connexion-modal .modal-content {
    overflow: auto;
  }
  .redirect-connexion-header-content, .redirect-connexion-text {
    padding: 0px;

  }
}

</style>



// WEBPACK FOOTER //
// src/views/auth/RedirectConnexionModal.vue